import { useQuery } from '@tanstack/react-query';

import {
  FetchIndividualsRequest,
  FetchIndividualsResponse,
  individualsService,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchEmployees = (
  {
    ids,
    status,
    companyId,
    friendlyId,
    payCalendarId,
    externalPayrollId,
    email,
    isTerminationDateSet,
    onUnpaidLeave,
    allowTracking,
    allowMarketing,
    query,
    sortBy,
    sort,
    page,
    size,
  }: Omit<FetchIndividualsRequest, 'role'>,
  options: {
    enabled?: boolean;
  } = {}
) => {
  const toast = useToast();

  return useQuery<FetchIndividualsResponse, Error>(
    [
      'fetchEmployees',
      ids,
      status,
      companyId,
      friendlyId,
      payCalendarId,
      externalPayrollId,
      email,
      isTerminationDateSet,
      onUnpaidLeave,
      allowTracking,
      allowMarketing,
      query,
      sortBy,
      sort,
      page,
      size,
    ],
    async () => {
      const response = await individualsService.fetchIndividuals({
        ids,
        status,
        role: ['EMPLOYEE'],
        companyId,
        friendlyId,
        payCalendarId,
        externalPayrollId,
        email,
        isTerminationDateSet,
        onUnpaidLeave,
        allowTracking,
        allowMarketing,
        query,
        sortBy,
        sort,
        page,
        size,
      });

      return response;
    },
    {
      enabled: options?.enabled ?? true, // <== support enabled
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: `Sorry, we failed to fetch the employees${
            companyId?.length ? ' for this company' : ''
          }. Please try again.`,
        });
      },
    }
  );
};

export default useFetchEmployees;
